window._ = require('lodash');

import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';
import {TNKC_TOKEN} from './service/constants.service';
import {API_URL} from './service/url.service';
import VueProgressBar from 'vue-progressbar';
import Swal from 'sweetalert2';

//todo use this import if you intend to use laravel echo socket stream for real time notification,
// import Echo from 'laravel-echo';

export const ConfigSetup = {
  initJQuery() {
    try {
      window.Popper = require('popper.js').default;
      window.$ = window.jQuery = require('jquery');  //comment out because on the build declaration code on webpack.mix.js
      require('./service/constants.service');
      require('bootstrap');
    } catch (e) {
      console.log(e);
    }
  },


  initAxios() {
    Vue.use(VueAxios, axios);
    axios.defaults.baseURL = API_URL;
    axios.interceptors.request.use((config) => {
          let token = localStorage.getItem(TNKC_TOKEN);
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
          }
          return config;
        },

        (error) => {
          return Promise.reject(error);
        },
    );

    let newVue = new Vue({});

    axios.interceptors.request.use(
        (config) => {
          newVue.$Progress.start(); // for every request start the progress
          return config;

        }, (error) => {
          newVue.$Progress.fail(); // for every request fail the progress
          return error;
        });

    axios.interceptors.response.use(response => {
      newVue.$Progress.finish(); // finish when a response is received
      return response;
    });
  },

  initSweetAlert2(){
     return window.swal = Swal;
  },

  initProgressBar() {
    Vue.use(VueProgressBar, {
      color: '#3ca3f8',
      failedColor: 'red',
      thickness: '5px',
      height: '1px',
      transition: {
        speed: '1s',
        opacity: '0.6s',
        termination: 100,
      },
      autoRevert: true,
      location: 'top',
      inverse: false,
    });
  },

  /**
   * Echo exposes an expressive API for subscribing to channels and listening
   * for events that are broadcast by Laravel. Echo and event broadcasting
   * allows your team to easily build robust real-time web applications.
   */
  initEchoNotification() {
    //     let token = localStorage.getItem('token');
    //     window.Pusher = require('pusher-js');
    //     window.Echo = new Echo({
    //         broadcaster: 'pusher',       //notification provider
    //         key: 'd619121410569f391cc3', //application key
    //         cluster: 'ap1',              //application cluster key
    //         encrypted: true,
    //         auth:{
    //             headers:{
    //                 Authorization : `Bearer ${token}`,
    //             }
    //         }
    //     });
  },

  initGlobalElementFocus(){
    Vue.directive('focus',{
      inserted : function(el){
        el.focus();
      }
    })
  }
};

